import { render, staticRenderFns } from "./NoActivePolls.vue?vue&type=template&id=0031d8f3&scoped=true"
import script from "./NoActivePolls.vue?vue&type=script&lang=js"
export * from "./NoActivePolls.vue?vue&type=script&lang=js"
import style0 from "./NoActivePolls.vue?vue&type=style&index=0&id=0031d8f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031d8f3",
  null
  
)

export default component.exports